import { Spinner } from 'react-bootstrap';
import * as E from './elements';

export const PriceValue = ({ loadingCheckoutValues, cartTotalBeforeDiscount, price, currency, className = '' }) => {
  if (loadingCheckoutValues) return <Spinner animation="border" size="sm" />;
  const priceNum = +price;
  const cartTotalBeforeDiscountNum = +cartTotalBeforeDiscount;
  if (cartTotalBeforeDiscountNum > priceNum) {
    return (
      <span className={className}>
        <E.Discount style={{ textDecoration: 'line-through', marginRight: 5 }}>
          {currency} {cartTotalBeforeDiscountNum.toFixed(2)}
        </E.Discount>
        <E.PriceWrapper>
          {currency} {priceNum.toFixed(2)}
        </E.PriceWrapper>
      </span>
    );
  }
  return (
    <E.PriceWrapper className={className}>
      {currency}
      {priceNum.toFixed(2)}
    </E.PriceWrapper>
  );
};
